export enum TreasuryStatementOperationType {
	INCOME = "Income",
	PAYOUT = "Payout",
	TRANSFER = "Transfer"
}
